import { nanoid } from '@reduxjs/toolkit';

const changeArrayItemIndex = <T>(
  arr: T[],
  fromIndex: number,
  toIndex: number,
): T[] => {
  const copyArr = [...arr];
  const startIndex = fromIndex < 0 ? copyArr.length + fromIndex : fromIndex;

  if (startIndex >= 0 && startIndex < copyArr.length) {
    const endIndex = toIndex < 0 ? copyArr.length + toIndex : toIndex;
    const [item] = copyArr.splice(fromIndex, 1);

    copyArr.splice(endIndex, 0, item);
  }

  return copyArr;
};

const convertArraysToOneLength = <T>(
  oldData: T[],
  newData: T[],
  correctDefaultValue: T,
): { oldData: T[]; newData: T[] } => {
  if (oldData.length > newData.length) {
    oldData.forEach((value, index) => {
      if (!newData[index]) {
        newData[index] = correctDefaultValue;
      }
    });
  } else {
    newData.forEach((value, index) => {
      if (!oldData[index]) {
        oldData[index] = correctDefaultValue;
      }
    });
  }
  return { oldData, newData };
};

const addIdsToValues = (data: any[]) => {
  return data.map((i) => ({ ...i, id: nanoid() }));
};

export { convertArraysToOneLength, changeArrayItemIndex, addIdsToValues };
